export default "__VITE_ASSET__023c0ac0__"